import Component from '../inherited/Component'

export default class CollectionClusters extends Component {
  constructor (elem, theme, options, ctx) {
    super(elem, theme, options, ctx)
  }

  mount () {
    if(this._elem.scrollWidth > this._elem.clientWidth) {
      this._elem.classList.add('will-scroll')
      this._elem.addEventListener('scroll', e => {
        if(this._elem.scrollLeft > 0) {
          this._elem.classList.add('has-scrolled')
        } else {
          this._elem.classList.remove('has-scrolled')
        }
      }, { passive: true })
    }
  }
}